import type { DeviceInfo } from '@/libs/comeAppSDK';
import type { AppVersionPopupConfigRes } from '@/types/api/user/app-upgrade';
import { atom } from 'jotai';

export * from './device-id';
export * from './balance';
export * from './userinfo';
export * from './session';
export * from './referral';
export * from './reward';
export * from './path-history';
export * from './swipe-navigation';
export * from './gullak-cash';
export * from './global-config';

interface User {
  name: string;
  accessToken: string | null;
}

export const userAtom = atom<User>({
  name: '',
  accessToken: null,
});

// 用于判断用户是否登录的原子
export const isLoginAtom = atom((get) => !!get(userAtom).accessToken);

// 用于触发 wagmi disconnect 的状态
export const shouldDisconnectWalletAtom = atom<boolean>(false);

// 用于判断是否显示轮播的原子
export const showHomePlayerAtom = atom<boolean | null>(null);

// 用于判断是否显示用户中心的原子
export const showUserCenterDrawerAtom = atom<boolean>(false);

// 用于跟踪 token 初始化是否完成
export const tokenInitializedAtom = atom<boolean>(false);

// 用于跟踪下载apk的banner是否展示
export const downloadBannerShowAtom = atom<boolean>(true);

// 用于判断是否显示包转移弹窗
export const transferPackageShowAtom = atom<boolean>(false);

// 用于记录包转移弹窗是否已展示
export const transferPackageIsShowAtom = atom<boolean>(false);

// 用于判断是否发起充值
export const transferPackageDepositAtom = atom<boolean>(false);

// 用于判断是否显示版本更新弹窗
export const appVersionUpdateShowAtom = atom<boolean>(false);

// 用于记录版本更新弹窗是否已展示
export const appVersionUpdateIsShowAtom = atom<boolean>(false);

// 版本更新弹窗数据
export const appVerionUpdateConfigAtom = atom<AppVersionPopupConfigRes>({
  releaseVersion: '',
  updateType: 0
});

// app设备信息
export const appDeviceInfoAtom = atom<Partial<DeviceInfo>>({
  appVersion: '',
  appId: ''
});

// 版本更新接口查询次数
export const appVersionUpdateTimesAtom = atom<number>(3);

// 版本更新-强制更新是否有弹窗等待
export const appVersionUpdateCacheAtom = atom<boolean>(false);
